import RussianBlockedBanner from 'pricing-pages-ui-components/banners/RussianBlockedBanner';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useCountryCode } from '../../hooks/useCurrencies';
import StarterPromotion2025BannerWrapper from './StarterPromotion2025BannerWrapper';
import { TrialDiscountBanner } from './TrialDiscountBanner';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BannerHierarchySection = ({
  screen
}) => {
  const isAppReady = useGlobalLoading();
  const countryCode = useCountryCode();
  const shouldShowRussianBlockedBanner = countryCode === 'RU';
  if (!isAppReady) {
    return null;
  }
  if (shouldShowRussianBlockedBanner) {
    return /*#__PURE__*/_jsx(RussianBlockedBanner, {});
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TrialDiscountBanner, {
      screen: screen
    }), /*#__PURE__*/_jsx(StarterPromotion2025BannerWrapper, {
      screen: screen
    })]
  });
};
export default BannerHierarchySection;